import * as React from 'react'

// Helper to get initial values (safe for SSR)
function getInitialValues() {
  if (typeof window === 'undefined') {
    return { isLandscape: false, isCompactLandscape: false }
  }
  const isLandscape = window.matchMedia('(orientation: landscape)').matches
  const isCompactLandscape = window.matchMedia('(orientation: landscape) and (max-height: 500px)').matches
  return { isLandscape, isCompactLandscape }
}

/**
 * Hook that detects device orientation (landscape vs portrait)
 * Also detects if in "compact landscape" mode (landscape with limited height)
 * which is common on phones rotated sideways
 */
export function useOrientation() {
  const [state, setState] = React.useState(getInitialValues)

  React.useEffect(() => {
    const orientationMql = window.matchMedia('(orientation: landscape)')
    const compactMql = window.matchMedia('(orientation: landscape) and (max-height: 500px)')
    
    const updateOrientation = () => {
      setState({
        isLandscape: orientationMql.matches,
        isCompactLandscape: compactMql.matches,
      })
    }
    
    // Listen for changes
    orientationMql.addEventListener('change', updateOrientation)
    compactMql.addEventListener('change', updateOrientation)
    
    return () => {
      orientationMql.removeEventListener('change', updateOrientation)
      compactMql.removeEventListener('change', updateOrientation)
    }
  }, [])

  return {
    isLandscape: state.isLandscape,
    isPortrait: !state.isLandscape,
    isCompactLandscape: state.isCompactLandscape,
  }
}
